import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const useRefreshData = (action: any) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(action());
    }, 180000); // every 3 minutes

    return () => clearInterval(intervalId);
  }, [dispatch, action]); 
};

export default useRefreshData;